/**
 * @generated SignedSource<<d9b7730e87e8c5da6ec851795c1a4157>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectsPanelQuery$variables = Record<PropertyKey, never>;
export type ProjectsPanelQuery$data = {
  readonly current_user: {
    readonly account: {
      readonly id: number;
      readonly projects: ReadonlyArray<{
        readonly id: number;
        readonly name: string;
        readonly team_id: number | null | undefined;
      }>;
      readonly teams: ReadonlyArray<{
        readonly id: number;
        readonly name: string;
        readonly projects: ReadonlyArray<{
          readonly id: number;
          readonly name: string;
        }>;
      }>;
    };
    readonly id: number;
  } | null | undefined;
};
export type ProjectsPanelQuery = {
  response: ProjectsPanelQuery$data;
  variables: ProjectsPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "users",
    "kind": "LinkedField",
    "name": "current_user",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "where",
                "value": {
                  "active": {
                    "_eq": true
                  },
                  "is_template": {
                    "_eq": false
                  }
                }
              }
            ],
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "projects",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "team_id",
                "storageKey": null
              }
            ],
            "storageKey": "projects(where:{\"active\":{\"_eq\":true},\"is_template\":{\"_eq\":false}})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "teams",
            "kind": "LinkedField",
            "name": "teams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "projects",
                "kind": "LinkedField",
                "name": "projects",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectsPanelQuery",
    "selections": (v2/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProjectsPanelQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a87bd25e01d737d7c66c51e36444fd25",
    "id": null,
    "metadata": {},
    "name": "ProjectsPanelQuery",
    "operationKind": "query",
    "text": "query ProjectsPanelQuery {\n  current_user {\n    id\n    account {\n      id\n      projects(where: {is_template: {_eq: false}, active: {_eq: true}}) {\n        id\n        name\n        team_id\n      }\n      teams {\n        id\n        name\n        projects {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5b5666a92d80c648a058a6a00dc7be68";

export default node;
